export default {
  questions: {
    common: {
      dropdownPlaceholder: 'Por favor, seleccione:'
    },
    comments: {
      additionalComments: 'Comentarios adicionales',
      enter: 'Ingrese su texto aquí',
      title: '¿Algún otro comentario que desee compartir con nosotros?' //Dynamic use

    },
    menuInsight: {
      areYouSureYouWantToClose: '¿Está seguro(a) de que desea cerrar?',
      theInformationYouHaveEnteredHere: 'La información que ha introducido aquí no se guardará',
      moreCharactersRequired: 'Introduzca tres o más caracteres para buscar su artículo.' // Deepl translated -> Requires proper translation

    },
    nps: {
      notVeryLikely: 'No es muy probable',
      sliderDesc: 'Pulse abajo para seleccionar una puntuación',
      sliderDirtyDesc: 'Deslice para cambiar su puntuación',
      veryLikely: 'Muy probable'
    },
    questions: {
      na: 'No aplica'
    },
    staff: {
      areYouSureYouWantToClose: '¿Está seguro(a) de que desea cerrar?',
      theInformationYouHaveEnteredHereWontBeSaved: 'La información que ha ingresado aquí no se guardará'
    },
    yesNoWhy: {
      whyIsThat: '¿A qué se debe esto?'
    },
    saveAndContinue: 'Guardar Continuar',
    areYouSureYouWantToClose: '¿Está seguro(a) de que desea cerrar?',
    theInformationYouHaveEnteredHere: 'La información que ha introducido aquí no se guardará'
  }
};